import { PageNames } from 'shared/constants/appConstants';
import { mapPageNameToFiltersList } from 'invoices/constants/FiltersOptionsData';
import { AwsCommonFields } from 'shared/constants/awsConstants';

const ACCOUNT_LEVEL_FILTERS = [AwsCommonFields.LINKED_ACCOUNT_ID];

const CLOUD_LEVEL_FILTERS = [AwsCommonFields.RESOURCE, AwsCommonFields.SERVICE, AwsCommonFields.FAMILY_TYPE];

export const sanitizeUrlFilters = ({
  filters,
  cloudType,
  currentDisplayedAccountFeatures,
  k8sUnified,
  cloudChanged,
  accountChanged,
}: {
  filters: Record<string, string[]>;
  cloudType: string;
  currentDisplayedAccountFeatures: string[];
  k8sUnified?: boolean;
  accountChanged?: boolean;
  cloudChanged?: boolean;
}): Record<string, string[]> => {
  if (!filters || Object.keys(filters).length === 0) {
    return filters;
  }

  const globalFiltersList = k8sUnified ? [AwsCommonFields.COST_GLOBAL_TYPE] : [];
  const fieldToFieldDistinctValuesMap = mapPageNameToFiltersList.get(PageNames.COST_AND_USAGE_EXPLORER)?.(
    cloudType,
    currentDisplayedAccountFeatures,
  );

  const k8sFieldToDistinctValuesMap = mapPageNameToFiltersList.get(PageNames.CUE_K8S)?.(cloudType);

  const availableFilters = [
    ...(fieldToFieldDistinctValuesMap || []),
    ...(k8sFieldToDistinctValuesMap || []),
    ...globalFiltersList,
  ];

  return Object.entries(filters).reduce((acc, [key, values]) => {
    if (CLOUD_LEVEL_FILTERS.includes(key) && cloudChanged) {
      return acc;
    }
    if (ACCOUNT_LEVEL_FILTERS.includes(key) && accountChanged) {
      return acc;
    }
    if (!availableFilters.includes(key)) {
      return acc;
    }
    return {
      ...acc,
      [key]: values,
    };
  }, {});
};
